import { customContextFactory } from '../../../../../../hooks';
import { useScheduleRequestDetails } from '../hooks';

type ContextType = Omit<ReturnType<typeof useScheduleRequestDetails>, 'providerValue'>;

export const [ScheduleRequestDetailsContextProvider, useScheduleRequestDetailsContext] =
  customContextFactory<ContextType>();
